import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';

const action = (
  state: IState,
  payloadAction: PayloadAction<{
    folderId: number;
    stationCode: string;
  }>,
) => {
  const { folderId, stationCode: removedStationCode } = payloadAction.payload;

  const updatedStationCodes = (
    state.catalogs.data[folderId].stationCodes || []
  ).filter((stationCode) => stationCode !== removedStationCode);

  state.catalogs.data = {
    ...state.catalogs.data,
    [folderId]: {
      ...state.catalogs.data[folderId],
      stationCodes: updatedStationCodes,
    },
  };
};

export default action;
